import { useTranslation } from 'react-i18next';
import { PublicLayout } from '@/components/layout';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-dark-800 dark:text-white mb-8">
          {t('termsPage.title')}
        </h1>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.objectTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.objectP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.objectP2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.accessTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.accessP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.accessP2')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.accessP3')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.servicesTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.servicesDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('termsPage.servicesItem1Label')}</strong> : {t('termsPage.servicesItem1Text')}</li>
              <li><strong>{t('termsPage.servicesItem2Label')}</strong> : {t('termsPage.servicesItem2Text')}</li>
              <li><strong>{t('termsPage.servicesItem3Label')}</strong> : {t('termsPage.servicesItem3Text')}</li>
              <li><strong>{t('termsPage.servicesItem4Label')}</strong> : {t('termsPage.servicesItem4Text')}</li>
              <li><strong>{t('termsPage.servicesItem5Label')}</strong> : {t('termsPage.servicesItem5Text')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.obligationsTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.obligationsDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li>{t('termsPage.obligationsItem1')}</li>
              <li>{t('termsPage.obligationsItem2')}</li>
              <li>{t('termsPage.obligationsItem3')}</li>
              <li>{t('termsPage.obligationsItem4')}</li>
              <li>{t('termsPage.obligationsItem5')}</li>
              <li>{t('termsPage.obligationsItem6')}</li>
              <li>{t('termsPage.obligationsItem7')}</li>
              <li>{t('termsPage.obligationsItem8')}</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.obligationsDisclaimer')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.ipTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.ipP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.ipP2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.liabilityTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.liabilityDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li>{t('termsPage.liabilityItem1')}</li>
              <li>{t('termsPage.liabilityItem2')}</li>
              <li>{t('termsPage.liabilityItem3')}</li>
              <li>{t('termsPage.liabilityItem4')}</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.liabilityDisclaimer')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.personalDataTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.personalDataText')}{' '}
              <a href="/privacy" className="text-lime-600 hover:text-lime-700 underline">{t('termsPage.personalDataLinkText')}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.pricingTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.pricingP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.pricingP2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.terminationTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.terminationP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('termsPage.terminationP2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.changesTosTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.changesTosText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.lawTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.lawText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('termsPage.contactTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('termsPage.contactText')} <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a>
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-12">
          {t('termsPage.lastUpdated')}
        </p>
      </div>
    </PublicLayout>
  );
};

export default Terms;
